export default __webpack_public_path__ + "static/media/KOD0077-min.1aed05d0.webp";